var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.36,
    height: 94.358,
    viewBox: "0 0 120.36 94.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-growth-6429795",
    transform: "translate(-12.336 -3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M12.49,95.98a2.186,2.186,0,0,1,1.232-2.841C53,77.6,101.826,45.45,123.782,8.122l-9.771,1.609a2.188,2.188,0,0,1-.706-4.319l14.5-2.381a2.18,2.18,0,0,1,2.513,1.806l2.348,14.271a2.188,2.188,0,1,1-4.319.706l-1.4-8.474c-9.919,16.422-25.783,33.189-46.113,48.691A282.574,282.574,0,0,1,15.331,97.212a2.32,2.32,0,0,1-.8.148A2.152,2.152,0,0,1,12.49,95.98Z",
    fill: "#f7edd6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpper);
export default __webpack_public_path__ + "static/media/arrow-upper.fe99fe414f857a158702420a206bf6eb.svg";
export { ForwardRef as ReactComponent };